import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { linkGreen } from '../../components/Shared/Shared';

export const useLevelTwoPageStyles = makeStyles({
  container: {
    backgroundColor: tokens.colorNeutralForegroundInverted,
    zIndex: 2,
    minHeight: '100vh',
    ...shorthands.margin('24px'),
    ...shorthands.padding('20px'),
    '@media (max-width: 320px)': {
      ...shorthands.margin('12px'),
      ...shorthands.padding('8px'),
    },
  },
  operationsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
  },
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '16px',
    paddingLeft: '0px',
    paddingRight: '40px',
    ':hover': { color: linkGreen },
  },
  buttonIcon: {
    marginRight: '8px',
  },
  separator: {
    marginRight: '16px',
  },
  text: {
    display: 'block',
    marginBottom: '24px',
  },
  subtitle: {
    fontSize: '18px',
    fontWeight: 600,
    display: 'block',
    marginBottom: '24px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '24px',
  },
  description: {
    display: 'block',
    marginBottom: '24px',
    marginTop: '24px',
    minHeight: '120px',
    fontSize: '14px',
  },
  banner: {
    backgroundColor: 'green',
    color: '#fff',
    ...shorthands.padding('12px'),
    width: '100%',
    textAlign: 'center',
    position: 'relative',
  },
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    columnGap: '16px',
    rowGap: '12px',
    marginBottom: '16px',
  },
  divider: {
    maxHeight: '1px !important',
  },
  footer: {
    height: '16px',
    maxHeight: '16px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  link: {
    color: linkGreen,
    fontSize: '14px',
    fontWeight: 400,
    textDecorationLine: 'underline',
    ':hover': {
      textDecorationLine: 'underline',
    },
    ':focus': {
      textDecorationLine: 'underline',
    },
  },
  careerStageProfileHeader: {
    height: '20px',
    maxHeight: '20px',
  },
  card: {
    width: '315px',
    maxWidth: '100%',
    height: '202px',
  },
  caption: {
    ...shorthands.margin('2px', 0, 0),
    paddingLeft: '20px',
    color: '#605e5c',
    overflow: 'hidden',
  },
  cspCardTitle: {
    color: '#323130',
    overflowY: 'hidden',
    textOverflow: 'ellipsis',
    height: '24px',
  },
  cardSubtitle: {
    color: '#323130',
  },
  cspDivider: {
    display: 'block',
    marginBottom: '24px',
    marginTop: '14px',
  },
  cspLink: {
    color: '#b836aa',
    fontSize: '14px',
    fontWeight: 400,
    textDecorationLine: 'underline',
    ':hover': {
      textDecorationLine: 'underline',
    },
    ':focus': {
      textDecorationLine: 'underline',
    },
  },
});
